import React from "react";
import { Table, Icon } from "semantic-ui-react";
import { convertToDollar } from "../../Helpers";
import "../../styles/list.scss";

const BCDashboardList = ({ ...props }) => {
  return (
    <Table unstackable fixed className="dashboardlist-table">
      <Table.Body>
        {props.data && props.data.map((item, i) => {
          return (
            <Table.Row key={"dashboardlist-row" + i} className={"dashboardlist-row"}>
              <Table.Cell className="dashboardlist-cell" width={props.isGreaterThanTablet ? 7 : 6}>
                <div>{props.nameProp ? item[props.nameProp] : item.name ? item.name : null}</div>
                <div className="dashboardlist-meta">{props.typeProp ? item[props.typeProp] : item.type ? item.type : null}</div>
              </Table.Cell>
              <Table.Cell className="dashboardlist-cell" singleLine textAlign="right" width={props.isGreaterThanTablet ? 5 : 6}>
                <b>{props.valueProp ? convertToDollar(item[props.valueProp]) : item.value ? convertToDollar(item.value) : null}</b>
              </Table.Cell>
              <Table.Cell className="dashboardlist-cell" textAlign="right" width={2}>
                <Icon className="dashboardlist-icon" name='angle right' size="large" />
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default BCDashboardList;